import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { PrivacyPage } from "@/pages/privacy";

export const Route = createFileRoute("/$lang/confidentialite")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "privacy");
    return pageHead({
      lang,
      pathWithoutLang: "/privacy",
      title: t("seo.title"),
      description: t("seo.description"),
    });
  },
  component: PrivacyPage,
});
